<button class="action-btn" fxHide fxShow.gt-sm mat-icon-button (click)="toggleFullscreen()" matTooltip="Toggle Fullscreen">
  @if (!isFullscreen) {
    <mat-icon>fullscreen</mat-icon>
  }
  @if (isFullscreen) {
    <mat-icon>fullscreen_exit</mat-icon>
  }
</button>
